import React from 'react';
import { Link } from 'react-router-dom';
import { IconCheck, IconProfile } from './OrganizerIcons';

const OrganizerProfileCompletion = ({ completion }) => {
  if (!completion) return null;

  const { items, percent } = completion;
  const progressWidth = Math.max(8, Math.min(100, percent));

  return (
    <aside className="org-profile-completion">
      <div className="org-profile-completion-header">
        <div className="org-profile-completion-title">
          <IconProfile />
          <span>Profile completion</span>
        </div>
        <span className="org-profile-completion-percent">{percent}%</span>
      </div>

      <p className="org-profile-completion-subtitle">
        Complete your profile and unlock a{' '}
        <strong>£100 discount voucher</strong> on any booking
      </p>

      <div className="org-profile-completion-bar" aria-hidden="true">
        <div className="org-profile-completion-bar-fill" style={{ width: `${progressWidth}%` }} />
      </div>

      <ul className="org-profile-completion-list">
        {items.map((item) => (
          <li
            key={item.id}
            className={`org-profile-completion-item ${item.done ? 'org-profile-completion-item--done' : ''}`}
          >
            <span className={item.done ? 'org-profile-completion-label--done' : ''}>{item.label}</span>
            {item.done ? (
              <span className="org-profile-completion-check" aria-label="Completed">
                <IconCheck />
              </span>
            ) : null}
          </li>
        ))}
      </ul>

      <Link to="/profile?section=account" className="org-profile-completion-link">
        Complete profile
      </Link>
    </aside>
  );
};

export default OrganizerProfileCompletion;
